export const FETCH_YOUR_AGENT_LIST = 'suburban/strategistV2/yourAgent/FETCH_YOUR_AGENT_LIST'
export const FETCH_YOUR_AGENT_LIST_SUCCESS =
  'suburban/strategistV2/yourAgent/FETCH_YOUR_AGENT_LIST_SUCCESS'
export const FETCH_YOUR_AGENT_LIST_ERROR =
  'suburban/strategistV2/yourAgent/FETCH_YOUR_AGENT_LIST_ERROR'

export const CLEAR_YOUR_AGENT_PHASE = 'suburban/strategistV2/yourAgent/CLEAR_YOUR_AGENT_PHASE'
